// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListDirectReportsQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['ID']['input'];
  filter: Types.ListDirectReportsFilterInput;
}>;

export type ListDirectReportsQuery = { __typename?: 'Query' } & {
  listDirectReports: { __typename?: 'ListDirectReports' } & Pick<Types.ListDirectReports, 'nonFilteredTotalCount'> & {
      items: Array<
        { __typename?: 'Employee' } & Pick<Types.Employee, 'id' | 'status'> & {
            generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
              Types.EmployeeGeneralInformation,
              'preferredFullName'
            > & {
                companyEmail: Types.Maybe<
                  { __typename?: 'EmployeeCompanyEmail' } & Pick<Types.EmployeeCompanyEmail, 'fullAddress'>
                >;
              };
            currentMainContract: Types.Maybe<
              { __typename?: 'EmployeeContract' } & Pick<
                Types.EmployeeContract,
                'id' | 'employeeCode' | 'contractType' | 'effectiveDateUntil'
              > & {
                  company: { __typename?: 'Company' } & Pick<Types.Company, 'id' | 'name' | 'countryId'> & {
                      country: { __typename?: 'Country' } & Pick<Types.Country, 'name'>;
                      probationReviewTerm: { __typename?: 'CompanyProbationReviewTerm' } & Pick<
                        Types.CompanyProbationReviewTerm,
                        'length' | 'mode'
                      >;
                    };
                }
            >;
            currentPosition: Types.Maybe<
              { __typename?: 'EmployeeJobHistory' } & Pick<
                Types.EmployeeJobHistory,
                'id' | 'level' | 'jobTitle' | 'team' | 'type' | 'departmentLead'
              > & {
                  businessUnit: { __typename?: 'BusinessUnit' } & Pick<Types.BusinessUnit, 'id' | 'name'> & {
                      division: { __typename?: 'Division' } & Pick<Types.Division, 'name'>;
                    };
                  department: { __typename?: 'Department' } & Pick<Types.Department, 'id' | 'name'>;
                  job: { __typename?: 'Job' } & Pick<Types.Job, 'id' | 'name'>;
                  location: { __typename?: 'Location' } & Pick<Types.Location, 'id' | 'name'>;
                }
            >;
            pendingManagerChangeReservation: Types.Maybe<
              { __typename?: 'ManagerChangeReservation' } & Pick<
                Types.ManagerChangeReservation,
                'id' | 'primaryManagerId' | 'dottedLineManagerId' | 'effectiveDate'
              >
            >;
          }
      >;
      allCandidates: { __typename?: 'ListDirectReportsAllCandidates' } & Pick<
        Types.ListDirectReportsAllCandidates,
        'contractTypes' | 'levels' | 'companyIds' | 'locationIds' | 'jobIds'
      >;
    };
};

export const ListDirectReportsDocument = /*#__PURE__*/ gql`
    query ListDirectReports($employeeId: ID!, $filter: ListDirectReportsFilterInput!) {
  listDirectReports(id: $employeeId, filter: $filter) {
    nonFilteredTotalCount
    items {
      id
      status
      generalInformation {
        preferredFullName
        companyEmail {
          fullAddress
        }
      }
      currentMainContract {
        id
        employeeCode
        contractType
        company {
          id
          name
          countryId
          country {
            name
          }
          probationReviewTerm {
            length
            mode
          }
        }
        effectiveDateUntil
      }
      currentPosition {
        id
        level
        businessUnit {
          id
          name
          division {
            name
          }
        }
        department {
          id
          name
        }
        job {
          id
          name
        }
        jobTitle
        level
        location {
          id
          name
        }
        team
        type
        departmentLead
      }
      pendingManagerChangeReservation {
        id
        primaryManagerId
        dottedLineManagerId
        effectiveDate
      }
    }
    allCandidates {
      contractTypes
      levels
      companyIds
      locationIds
      jobIds
    }
  }
}
    `;

/**
 * __useListDirectReportsQuery__
 *
 * To run a query within a React component, call `useListDirectReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDirectReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDirectReportsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListDirectReportsQuery(
  baseOptions: Apollo.QueryHookOptions<ListDirectReportsQuery, ListDirectReportsQueryVariables> &
    ({ variables: ListDirectReportsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDirectReportsQuery, ListDirectReportsQueryVariables>(ListDirectReportsDocument, options);
}
export function useListDirectReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDirectReportsQuery, ListDirectReportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDirectReportsQuery, ListDirectReportsQueryVariables>(
    ListDirectReportsDocument,
    options,
  );
}
// @ts-expect-error
export function useListDirectReportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListDirectReportsQuery, ListDirectReportsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDirectReportsQuery, ListDirectReportsQueryVariables>;
export function useListDirectReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListDirectReportsQuery, ListDirectReportsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDirectReportsQuery | undefined, ListDirectReportsQueryVariables>;
export function useListDirectReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListDirectReportsQuery, ListDirectReportsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListDirectReportsQuery, ListDirectReportsQueryVariables>(
    ListDirectReportsDocument,
    options,
  );
}
export type ListDirectReportsQueryHookResult = ReturnType<typeof useListDirectReportsQuery>;
export type ListDirectReportsLazyQueryHookResult = ReturnType<typeof useListDirectReportsLazyQuery>;
export type ListDirectReportsSuspenseQueryHookResult = ReturnType<typeof useListDirectReportsSuspenseQuery>;
